import { useMemo } from "react"

import { Room } from "shared/types/Room"

import { useProjectPermissions } from "entities/projects/model/useProjectPermissions"
import { useProjectRequestMonitor } from "entities/projects/model/useProjectRequestState"
import { readonlyProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useRoomMultiActionHandlers } from "features/room-management/model/useRoomMultiActionHandlers"
import { useRoomMultiPrice } from "features/room-management/model/useRoomMultiPrice"

import { RoomMultiSelectSidebarModel } from "../RoomMultiSelectSidebar"

export interface UseRoomMultiSelectSidebarModelArgs {
  projectID: string
  rooms: Room[]

  isShared?: boolean
}

export function useRoomMultiSelectSidebarModel({
  projectID,
  rooms,

  isShared
}: UseRoomMultiSelectSidebarModelArgs): RoomMultiSelectSidebarModel {
  const { isUpdatingChildren } = useProjectRequestMonitor({ projectID })
  const { permissions } = useProjectPermissions({ projectID })
  const handlers = useRoomMultiActionHandlers({
    projectID,
    rooms,
    permissions: permissions ?? readonlyProjectPermissions
  })
  const roomIDs = useMemo(() => rooms.map(room => room.id), [rooms])

  const { priceTotal, isLoading: isLoadingPrice } = useRoomMultiPrice({
    projectID,
    roomIDs,
    skip: isShared
  })

  return {
    projectID,
    rooms,
    callbacks: handlers,
    isDisabled: isUpdatingChildren,
    price: priceTotal,
    isLoadingPrice,
    hideControls: !handlers.onDelete
  }
}
